export const ROLES = {
    VISITOR: "visitor",
    USER: "user",
    ADMIN: "admin",
    TESTER: "tester",
}

export const ROLES_ARRAY = Object.values(ROLES);

//Edit possible if admin, or data createdBy is currentUser
export const canEditOthersInput = (data, hasRole, currentUser) => {
    return canInput(hasRole) && (data?.id ? (hasRole(ROLES.ADMIN) || data?.createdBy == currentUser.id) : true)
}
export const canInput = (hasRole) => {
    return hasRole(ROLES.USER) || hasRole(ROLES.ADMIN)
}
export const isTankEmpty = (data, tank) => {
    return !data?.idBatch && !tank?.lastBatchTransfer?.batch.id;
}

export const useRoles = ({data = null, tank = null, hasRole, currentUser}) => {

  //If tank is empty of batch, can't input. If no tank passed, go on
  const _isTankEmpty = tank ? isTankEmpty(data, tank) : false;
  //Edit if admin, or created by, and if no data, check there's a batch
  const _canEdit = canEditOthersInput(data, hasRole, currentUser) && !_isTankEmpty;
  //Is user more than a visitor ?
  const _canInput = canInput(hasRole);

  return {isTankEmpty: _isTankEmpty, canEdit: _canEdit, canInput: _canInput}
}

/**
 * New resource-based permission system
 */

/**
 * Check if user has permission for a specific resource and operation
 * @param hasRole - The hasRole function from useAuth
 * @param resource - The resource name (e.g., 'Feeding', 'Event')
 * @param operation - The operation ('read', 'create', 'update', 'delete')
 * @param siteId - Optional site ID for site-specific permissions
 */
export const hasResourcePermission = (hasRole, resource: string, operation: 'read' | 'create' | 'update' | 'delete', siteId?: string | number) => {
  const permissionString = siteId ? `${resource}.${operation}.${siteId}` : `${resource}.${operation}`;
  return hasRole(permissionString);
}

interface PermissionsForResource {
    canReadResource: boolean
    canCreateResource: boolean
    canUpdateResource: boolean
    canDeleteResource: boolean
    canInput: boolean
    canEdit: boolean
    canDelete: boolean
    isTankEmpty: boolean
}
/**
 * Calculate form permissions based on resource permissions and data ownership
 * @param hasRole - The hasRole function from useAuth
 * @param currentUser - The current user object
 * @param resource - The resource name (e.g., 'Feeding', 'Event')
 * @param data - The data object being edited (null for new items)
 * @param siteId - Optional site ID for site-specific permissions
 * @param tank - Optional tank object for tank empty checks
 */
export const useResourcePermissions = ({
  hasRole,
  currentUser,
  resource,
  data = null,
  siteId = null,
  tank = null
}: {
  hasRole: (permission: string) => boolean;
  currentUser: any;
  resource: string;
  data?: any;
  siteId?: string | number;
  tank?: any;
}):PermissionsForResource => {
  
  // Check tank empty status if tank is provided
  const _isTankEmpty = tank ? isTankEmpty(data, tank) : false;
  
  // Check resource permissions
  const canReadResource = hasResourcePermission(hasRole, resource, 'read', siteId);
  const canCreateResource = hasResourcePermission(hasRole, resource, 'create', siteId);
  const canUpdateResource = hasResourcePermission(hasRole, resource, 'update', siteId);
  const canDeleteResource = hasResourcePermission(hasRole, resource, 'delete', siteId);
  
  // Calculate derived permissions
  const canInput = canCreateResource;
  const canEdit = data?.id 
    ? (canUpdateResource || (data?.createdBy === currentUser?.id && canCreateResource)) && !_isTankEmpty
    : canCreateResource && !_isTankEmpty;
  const canDelete = data?.id 
    ? (canDeleteResource || (data?.createdBy === currentUser?.id && canCreateResource))
    : false;
  
  return {
    // Individual permissions
    canReadResource,
    canCreateResource,
    canUpdateResource,
    canDeleteResource,
    
    // Derived permissions
    canInput,
    canEdit,
    canDelete,
    
    // Additional state
    isTankEmpty: _isTankEmpty
  };
}